import React, { useEffect } from "react"
import { FiRss, FiTwitter } from "react-icons/fi"

import { withMicrocopy } from "~contexts/MicrocopyContext"
import Link from "~components/Link"
import ThreeColumnLayout from "~layouts/ThreeColumnLayout"
import InternationalSites from "./InternationalSites"

import * as style from "./Footer.module.scss"

import List from "./List"

const Footer = ({ microcopy, color, alignment = "wide" }) => {
  useEffect(() => {
    const isScriptAdded = [].slice.call(document.getElementsByTagName("script"))
      .filter((e) => e.src.indexOf("consent.trustarc.com") >= 0).length
    if (process.env.GATSBY_COOKIE_BANNER_SOURCE_LINK !== undefined && !isScriptAdded) {
      const script = document.createElement("script")
      script.src = process.env.GATSBY_COOKIE_BANNER_SOURCE_LINK
      script.async = "async"
      script.crossOrigin = ""
      script.importance = "high"
      document.body.appendChild(script)
    }
  }, [])

  return (
    <footer className={style.footer} data-color={color}>
      <section>
        <ThreeColumnLayout alignment={alignment} padding={false}>
          <></>
          <SocialLinks microcopy={microcopy} />
        </ThreeColumnLayout>
      </section>
      <section>
        <ThreeColumnLayout alignment={alignment} padding={false}>
          <></>
          <Lists microcopy={microcopy} />
        </ThreeColumnLayout>
      </section>
      <section>
        <ThreeColumnLayout alignment={alignment} padding={false}>
          <></>
          <List id="footer.bottom" microcopy={microcopy} showCopyright />
        </ThreeColumnLayout>
      </section>
      <div id="consent_blackbar" />
      <div id="teconsent" />
    </footer>
  )
}

const SocialLinks = ({ microcopy }) => (
  <>
    <Link
      microcopy={microcopy}
      aria-label={microcopy.text(
        "footer.categories.company.links.devblog.text",
      )}
      to={microcopy.text("footer.categories.company.links.devblog.url")}
    >
      <FiRss />
    </Link>
    <Link
      microcopy={microcopy}
      aria-label={microcopy.text(
        "footer.categories.company.links.twitter.text",
      )}
      to={microcopy.text("footer.categories.company.links.twitter.url")}
    >
      <FiTwitter />
    </Link>
  </>
)

const Lists = ({ microcopy }) => (
  <>
    <List id="footer.categories.company" microcopy={microcopy} showTitle />
    <List id="footer.categories.tooling" microcopy={microcopy} showTitle />
    <List id="footer.categories.llms" microcopy={microcopy} showTitle />
    <List id="footer.categories.support" microcopy={microcopy} showTitle />
    <InternationalSites microcopy={microcopy} />
  </>
)

export default withMicrocopy(Footer)
